import {
  maxMobile,
  maxWidth, primaryHeadingColor, retina, secondaryFont, wMedium,
} from 'Utils/utilsStyle';
import React from 'react';
import styled from 'styled-components';

const StyleWrapper = styled.div`
&.cant-find-person-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  .text-no-data {
    color: ${primaryHeadingColor};
    text-align: center;
    font-family: ${secondaryFont};
    font-size: 26px;
    font-weight: ${wMedium};
    line-height: 40px;
    letter-spacing: -0.75px;
    @media all and (max-width: ${maxWidth}), ${retina} { 
      font-size: 20px;
      line-height: 30px;
    }
    @media all and (max-width: ${maxMobile}) {
      font-size: 18px;
      line-height: 24px;
    }
  } 
} 
`;
type Props = {
  firstText?: string,
  secondText?: string,
} & typeof defaultProps;

const defaultProps = {
  firstText: '',
  secondText: '',
};
const NoDataFoundComponent = function NoDataFoundComponent(props: Props) {
  const { firstText, secondText } = props;
  return (
    <StyleWrapper className="cant-find-person-div">
      {firstText !== '' ? (
        <span className="text-no-data">{firstText}</span>
      ) : null}
      <span className="text-no-data">{secondText}</span>
    </StyleWrapper>
  );
};
NoDataFoundComponent.defaultProps = defaultProps;
export default NoDataFoundComponent;
